import { dateFormatter } from "../../utils/dateUtils";
import { formatCurrency } from "../../constants/utils";

export const formatDateRange = (start, end) => {
  if (!start && !end) return "N/A";
  if (!start && end) return `Till ${dateFormatter(end)}`;
  if (start && !end) return `From ${dateFormatter(start)}`;
  return `${dateFormatter(start)} - ${dateFormatter(end)}`;
};

export const normalizePromotions = (items = [], currency = "USD") =>
  items.map((promo, index) => {
    const discountValue = promo?.discountValue;
    let discountText = "N/A";
    if (promo?.isDoW && !discountValue) {
      discountText = "DoW";
    } else if (discountValue !== null && discountValue !== undefined) {
      if (discountValue === "Multi") {
        discountText = `${discountValue}`;
      } else {
        const suffix = promo?.discountType === "1" ? ` ${currency}` : "%";
        discountText = `${discountValue}${suffix}`;
      }
    }

    const stayStart = promo?.stayDates?.start ?? promo?.stayDates?.from ?? null;
    const stayEnd = promo?.stayDates?.end ?? promo?.stayDates?.to ?? null;
    const bookingStart =
      promo?.bookingWindow?.start ?? promo?.bookingWindow?.from ?? null;
    const bookingEnd =
      promo?.bookingWindow?.end ?? promo?.bookingWindow?.to ?? null;

    // Handle revenue - it might be a number, string, or null/undefined
    const revenueText =
      promo?.revenue == null ? "N/A" : formatCurrency(promo.revenue, currency);

    return {
      id: promo?.id ?? promo?.promoCodeId ?? index,
      promoName: promo?.name ?? promo?.promoName ?? "N/A",
      status: promo?.status ?? "N/A",
      statusType:
        (promo?.status ?? "").toLowerCase() === "inactive"
          ? "inactive"
          : "active",
      discount: discountText,
      stayDates: formatDateRange(stayStart, stayEnd),
      bookingWindow: formatDateRange(bookingStart, bookingEnd),
      created: promo?.created
        ? dateFormatter(promo.created.split("T")[0])
        : "N/A",
      revenue: revenueText,
      currencyCode: currency, // Store currency for reference
    };
  });

export const normalizeReservations = (items = []) =>
  items.map((reservation, index) => {
    const confId =
      reservation?.confirmationCode ||
      reservation?.confirmationId ||
      reservation?.confId ||
      `reservation-${index}`;

    const arrivalDateRaw =
      reservation?.checkInDate ||
      reservation?.arrivalDate ||
      reservation?.arrival ||
      null;

    const bookingDateRaw =
      reservation?.bookingCreationDate || reservation?.bookingCreation || null;

    return {
      id: confId,
      confId,
      demandClient:
        reservation?.demandClientName ||
        reservation?.clientName ||
        reservation?.demandClient ||
        "N/A",
      status: reservation?.statusValue || reservation?.status || "N/A",
      statusType: (reservation?.statusValue || reservation?.status || "")
        .toLowerCase()
        .includes("cancel")
        ? "inactive"
        : "active",
      crsId:
        reservation?.crsBookingId ||
        reservation?.crsId ||
        reservation?.crsConfirmation ||
        "N/A",
      ratePlan: reservation?.ratePlanName || reservation?.ratePlan || "N/A",
      pmsId:
        reservation?.pmsConfirmationCode ||
        reservation?.pmsId ||
        reservation?.pmsConfirmation ||
        "N/A",
      bookingCreationDate: bookingDateRaw
        ? dateFormatter(bookingDateRaw.split("T")[0])
        : "N/A",
      cxlId:
        reservation?.cancellationId ||
        reservation?.cxlId ||
        reservation?.cancellationCode ||
        "N/A",
      guestName:
        reservation?.guestName ||
        [reservation?.guestFirstName, reservation?.guestLastName]
          .filter(Boolean)
          .join(" ") ||
        "N/A",
      arrivalDate: arrivalDateRaw ? dateFormatter(arrivalDateRaw) : "N/A",
      los:
        reservation?.lengthOfStay ||
        reservation?.los ||
        reservation?.stayLength ||
        "N/A",
    };
  });
